export default {"src":"/_next/static/media/ic_skillz_s.1f2a79a3.svg","height":32,"width":38,"blurWidth":0,"blurHeight":0};